/**
 * cn.ts — the standard clsx+tailwind-merge class-name helper used by every
 * shadcn/ui-style component (this project's primitives in
 * src/components/ui follow that same, widely-used pattern: unstyled Radix
 * behavior + Tailwind classes + cva variants, not a copied component
 * library). clsx resolves conditional class expressions; twMerge then
 * dedupes conflicting Tailwind utilities (e.g. a caller passing
 * `p-2` to override a component's default `p-4`) so the last one wins
 * instead of both being emitted.
 */
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
